import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { errorMessages } from "../../../constants/errorMessages";
import { Switch } from "@mui/material";
import "./ClinicHandler.scss";
import { regex } from "../../../constants/regex";
import { Roles } from "../../../constants/data/Roles";
import { useAuth } from "../../../context/AuthProvider";
// import { useAuth } from "../../../context/AuthProvider";
// import { Utility } from "../../../utils/Utility";
function ClinicHandler(props: any) {
  const [clinicStatus, setClinicStatus] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>();
  const [practitionersData, setPractitionersData] = useState([]);
  const [practiceManagersData, setPracticeManagersData] = useState([]);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [clinicHandlerDetails, setClinicHandlerDetails] = useState<any>();
  useEffect(() => {
    setClinicHandlerDetails(props?.clinicDetails);
  }, [props?.clinicDetails]);
  const { formRef } = props;
  const auth = useAuth();

  useEffect(() => {}, [clinicHandlerDetails]);
  return (
    <div className="clinic-wrapper">
      {/* {auth?.authClaims?.role?.toUpperCase() === Roles.supportUser && ( */}
      <div className="clinic-status-wrapper mt-3">
        Status
        <div
          className={
            "clinic-status d-flex align-items-center justify-content-between mt-2 px-4"
          }
        >
          <div className="clinic-status-label">Active</div>
          <Switch
            checked={clinicStatus}
            onChange={(e) => {
              setClinicStatus(!clinicStatus);
              // setClinicStatus(clinicHandlerDetails?.clinicId);
            }}
            onClick={(e: { stopPropagation: () => void }) => {
              e.stopPropagation();
            }}
            // disabled={auth?.authClaims?.role?.toUpperCase() !== Roles.supportUser}
          />
        </div>
      </div>
      {/* )} */}
      <div className="mt-5 clinic-details-wrapper px-4">
        <div className="pt-4 clinic-details-label">
          First Name
          <div
            className="mt-1 clinic-details-value"
            title={clinicHandlerDetails?.firstName}
          >
            {clinicHandlerDetails?.firstName}
          </div>
        </div>
        <div className="pt-4 clinic-details-label">
          Last Name
          <div
            className="mt-1 clinic-details-value"
            title={clinicHandlerDetails?.lastName}
          >
            {clinicHandlerDetails?.lastName}
          </div>
        </div>
        <div className="pt-4 clinic-details-label">
          Email Address
          <div
            className="mt-1 clinic-details-value"
            title={clinicHandlerDetails?.emailAddress}
          >
            {clinicHandlerDetails?.emailAddress}
          </div>
        </div>
        <div className="pt-4 clinic-details-label">
          Contact
          <div
            className="mt-1 clinic-details-value"
            title={clinicHandlerDetails?.contactNumber}
          >
            {clinicHandlerDetails?.contactNumber}
          </div>
        </div>
        <div className="pt-4 clinic-details-label">
          Clinic
          <div
            className="mt-1 clinic-details-value"
            title={clinicHandlerDetails?.clinicName}
          >
            {clinicHandlerDetails?.clinicName}
          </div>
        </div>
        <div className="pt-4 clinic-details-label">
          Address
          <div
            className="mt-1 pb-5 clinic-details-value"
            title={clinicHandlerDetails?.clinicAddress}
          >
            {clinicHandlerDetails?.clinicAddress}
          </div>
        </div>
      </div>
      {errorMessage && (
        <>
          <div className="login-error-message p-4 mt-4">
            <span className="error-message">{errorMessage} </span>
          </div>
        </>
      )}
    </div>
  );
}

export default ClinicHandler;
